import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { gameStore, GameState } from '../game/store';
export function InventoryHUD() {
  const [state, setState] = useState<GameState>(gameStore.getState());
  useEffect(() => gameStore.subscribe(setState), []);
  const handleUse = (id: string) => gameStore.useItem(id);
  return <div className="flex flex-col gap-2 pointer-events-auto" data-id="element-108">
      {/* Gold */}
      <div className="flex items-center gap-2 bg-black/60 border border-amber-900/50 px-3 py-1.5 backdrop-blur-sm" data-id="element-109">
        <span className="text-amber-400 text-lg" data-id="element-110">⦾</span>
        <span className="text-amber-300 font-bold tracking-widest text-sm uppercase" data-id="element-111">
          {state.gold} Gold
        </span>
      </div>

      {/* Inventory */}
      {state.inventory.length > 0 && <div className="bg-black/60 border border-gray-800 backdrop-blur-sm p-2 max-w-xs" data-id="element-112">
          <div className="text-gray-500 text-xs uppercase tracking-widest mb-2 px-1" data-id="element-113">
            Inventory
          </div>
          <div className="flex flex-col gap-1" data-id="element-114">
            {state.inventory.map(item => <motion.button key={item.id} whileHover={{
          x: 2,
          backgroundColor: 'rgba(255,255,255,0.05)'
        }} onClick={() => handleUse(item.id)} className="flex items-center justify-between gap-3 px-2 py-1 text-left text-sm group" title={item.description} data-id="element-115">
                <span className="text-gray-200 truncate" data-id="element-116">{item.name}</span>
                <span className="text-gray-500 text-xs font-mono" data-id="element-117">
                  ×{item.quantity || 1}
                </span>
              </motion.button>)}
          </div>
          <div className="text-gray-700 text-[10px] uppercase tracking-widest mt-1 px-1 italic" data-id="element-118">
            Click to use
          </div>
        </div>}
    </div>;
}